import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Header, Segment } from 'semantic-ui-react';
import LoadingComponent from '../../app/layout/LoadingComponent';
import { Activity } from '../../app/models/activity';
import { useStore } from '../../app/stores/store';
import DynamicTableFrontEnd from '../DynamicTable/DynamicTableFrontEnd';

function DynamicMasterTable() {
  const { WorkLevelStore, commonStore, reportStore } = useStore();
  const {
    selectedWorkLevelItem,
    loadWorkLevelWithItem,
    loadingMasterComponent,
  } = WorkLevelStore;
  const { userReadableDateFormat } = commonStore;
  const { ismasterTitle } = reportStore;
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    if (id) {
      WorkLevelStore.masterReportsId = id;
      loadWorkLevelWithItem(id);
    }
    // eslint-disable-next-line
  }, [id]);

  const tableData: Activity[] = [];
  (selectedWorkLevelItem as any)?.forEach((x: Activity) => {
    tableData?.push({
      ...x,
      movementdate: userReadableDateFormat(x.movementdate),
      movement_Time: userReadableDateFormat(x.movement_Time),
      maintenance: userReadableDateFormat(x.maintenance),
      receivingdate: userReadableDateFormat(x.receivingdate),
      status_Time: userReadableDateFormat(x.status_Time),
      itemCreatedAt: userReadableDateFormat(x.itemCreatedAt),
    });
  });

  // Dashboard asset table data filter
  // filter to check is approved in delivery
  const removeCol =
    'isReceiving,isDelivery,isReceivingOrder,files,assignedUsers,comments,itemHistory,orders,itemDeliveryRequest,inwards,receivings,host,isDeleted,isActive,cast,thumbnail_large,thumbnail_small,groove_type,speed_and_speed_adjustment,number_of_channels_and_sound_channel_map,file_format_name_and_version,analog_media,format_in_terms_of_broadcast_standards,bits_per_sample_and_sampling_description,songs,physcial_format,host,hostUsername,originIndia,itemCreatedAt,inactive,isgoing,ishost,clearedon,typeid,metaData,thumbnail,preview,proxy,elementtypeid';
  const MasterTable = JSON.parse(JSON.stringify(tableData));
  MasterTable.map((i: any) => removeCol.split(',').map((j) => delete i[j]));

  const [showText, setShow] = useState(false);
  useEffect(() => {
    setShow(true);
    // eslint-disable-next-line
  }, [selectedWorkLevelItem?.items]);

  const assetTableData = (
    <DynamicTableFrontEnd
      data={MasterTable}
      name={'MasterTable'}
      actiontype={'editdel'}
    />
  );
  if (loadingMasterComponent) return <LoadingComponent />;
  return (
    <>
      {showText && (
        <Segment>
          <Header
            icon="list"
            size="huge"
            dividing
            as="h1"
            content={ismasterTitle}
            sub
            color="grey"
          />
          {assetTableData}
        </Segment>
      )}
    </>
  );
}

export default observer(DynamicMasterTable);
